import type { UserStatus } from "./constant";

export const getStatusColor = (status: UserStatus) => {
	switch (status) {
		case "available":
			return "#00DCFE";
		case "busy":
			return "#fbbf24";
		case "off duty":
			return "#dc2626";
		default:
			return "#00DCFE";
	}
};

export function getRandomColor(name?: string) {
	if (name) {
		let hashValue = name.split("").reduce((acc, char) => {
			return char.charCodeAt(0) + (acc << 6) + (acc << 16) - acc;
		}, 0);
		hashValue = Math.abs(hashValue);
		const hexColor = `#${(hashValue % 0xffffff).toString(16).padStart(6, "0")}`;
		return hexColor;
	}
	const letters = "BCDEF".split("");
	let color = "#";
	for (let i = 0; i < 6; i++) {
		color += letters[Math.floor(Math.random() * letters.length)];
	}
	return color;
}
